import { render } from "./web-share-api-button.vue?vue&type=template&id=5e7a22f6"
import script from "./web-share-api-button.vue?vue&type=script&lang=js"
export * from "./web-share-api-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__